import { Locale } from '@core/Entities/Locale/Locale.entity';
import { getFormattedCurrency } from '@core/Utils/Intl/GetFormattedCurrency';
import { Typography } from '@gds/Typography/Typography';
import { useAtomValue } from 'jotai';

import { calculationAtom } from '../../../Atoms/Calculation.atom';
import { CalculationProduct } from '../../../Entities/Calculation.entity';
import { getValueFormatterForProduct } from '../../../Utils/getValueFormatterForProduct';
import { InfoBubble } from '../../InfoBubble/InfoBubble';
import { CalculatorMessages } from '../Calculator.messages';
import { isRci } from '../Helpers/FinanceMap';

import styles from './InsuranceSummary.module.css';

type InsuranceSummaryProps = {
  getSelectedAdditionalServices: Array<{ label: string; serviceMonthlyRate: number }>;
  product: CalculationProduct;
  locale: Locale;
  summaryStrings: CalculatorMessages;
  insuranceTitleInfoBubble: string | undefined;
  insuranceTotalMonthly: string | undefined;
};

const InsuranceSummary = ({
  getSelectedAdditionalServices,
  locale,
  summaryStrings,
  insuranceTitleInfoBubble,
}: InsuranceSummaryProps) => {
  const calculation = useAtomValue(calculationAtom)!;
  const allCaptives = calculation?.captiveId;
  const isCurrentRci = isRci(allCaptives);
  const valueFormatter = getValueFormatterForProduct(allCaptives);

  return (
    <div>
      {isCurrentRci && (
        <span>
          <InfoBubble header={summaryStrings.insuranceInfo} content={insuranceTitleInfoBubble} />
        </span>
      )}
      <li className={styles.additionalServices}>
        <ul>
          {getSelectedAdditionalServices.map((service, index) => (
            <li key={index}>
              <span>{service.label}</span>
              <Typography Component="span" variant="body2">
                {getFormattedCurrency(valueFormatter(service.serviceMonthlyRate), locale)}
                <span>{summaryStrings.totalMonthly}</span>
              </Typography>
            </li>
          ))}
        </ul>
      </li>
    </div>
  );
};

export default InsuranceSummary;
